<!--
 * @Author: 田鑫
 * @Date: 2021-10-20 16:20:20
 * @LastEditors: 田鑫
 * @LastEditTime: 2021-11-05 14:35:38
 * @Description: 标签管理
-->

<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>门诊预约问诊管理</el-breadcrumb-item>
        <el-breadcrumb-item>专家标签管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="标签搜索：" prop="label">
          <el-input v-model="listParams.label" placeholder="请输入标签关键字" @keyup.enter.native="searchTree"></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-button @click="searchTree" type="primary">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="hx-form-container box-shadow">
      <el-popover placement="top" v-model="visible">
        <div style="display: flex">
          <el-input v-model="label" size="small" @keyup.enter.native="addRootNode"></el-input>
          <el-button style="margin-left: 10px" @click="addRootNode" type="primary" size="small">保存</el-button>
        </div>
        <el-button type="primary" slot="reference">添加一级节点</el-button>
      </el-popover>

      <el-tree v-loading="loading" style="margin-top: 20px" :data="treeList" :props="defaultProps" node-key="id" :expand-on-click-node="false" :filter-node-method="filterNode" ref="tree">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <span>
            <el-popover placement="top" width="160" v-model="data.addVisible">
              <div style="display: flex">
                <el-input v-model="label" size="small" @keyup.enter.native="addLabel(data)"></el-input>
                <el-button style="margin-left: 10px" @click="addLabel(data)" type="primary" size="small">保存</el-button>
              </div>
              <i slot="reference" class="el-icon-circle-plus mgl10" @click="addShow(data)"></i>
            </el-popover>
            <el-popover placement="top" width="160" v-model="data.editVisible">
              <div style="display: flex">
                <el-input v-model="label" size="small" @keyup.enter.native="editLabel(data)"></el-input>
                <el-button style="margin-left: 10px" @click="editLabel(data)" type="primary" size="small">保存</el-button>
              </div>
              <i slot="reference" class="el-icon-edit-outline mgl5" @click="editShow(data)"></i>
            </el-popover>

            <confirm-button v-if="data.subDepartments.length === 0" type="text" :title="`确认要删除&quot;${data.name}&quot;吗？`" @confirmed="deleteLabel(node, data)">
              <i class="el-icon-delete mgl5"></i>
            </confirm-button>
          </span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        label: "",
      },
      treeList: [],
      visible: false,
      label: "",
      defaultProps: {
        children: "subDepartments",
        label: "name",
      },
      loading: false,
    };
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.loadTableData();
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.label = "";
      }
    },
  },
  methods: {
    loadTableData() {
      this.loading = true;
      this.$http({
        url: global.apiUrl + "/medical/department/list",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            let treeList = res.body.data;
            if (treeList && treeList.length > 0) {
              this.treeList = this.recursive(treeList);
            }
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch(err => {
          console.error(err);
          this.loading = false;
        });
    },
    /**
     * @description: 递归赋值
     * @param {*} treeList
     * @return {*}
     */
    recursive(treeList) {
      return treeList.map(item => {
        if (item.children && item.children.length > 0) {
          this.recursive(item.children);
        } else {
          return Object.assign(item, {
            addVisible: false,
            editVisible: false,
          });
        }
      });
    },
    searchTree() {
      this.$refs.tree.filter(this.listParams.label);
    },
    /**
     * @description: 添加根节点
     * @param {*}
     * @return {*}
     */
    addRootNode() {
      this.$http
        .post(global.apiUrl + `/medical/department/save`, {
          name: this.label,
        })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            const resData = res.body.data;
            const rootData = Object.assign(
              {},
              {
                id: resData.id,
                name: resData.name,
                subDepartments: [],
                addVisible: false,
                editVisible: false,
              }
            );
            this.treeList = this.treeList.concat(rootData);
            this.visible = false;
            this.label = "";
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 过滤节点
     * @param {*} value
     * @param {*} data
     * @return {*}
     */
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    /**
     * @description: 添加弹出框显示
     * @param {*} data
     * @return {*}
     */
    addShow(data) {
      this.$set(data, "editVisible", false);
      this.label = "";
    },
    /**
     * @description: 添加标签
     * @param {*} data
     * @return {*}
     */
    addLabel(data) {
      this.$http
        .post(global.apiUrl + `/medical/department/save`, {
          name: this.label,
          parentId: data.id,
        })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            const resData = res.body.data;
            const newData = {
              id: resData.id,
              name: resData.name,
              subDepartments: [],
              addVisible: false,
              editVisible: false,
            };
            if (!data.subDepartments) {
              this.$set(data, "children", []);
            }
            data.subDepartments.push(newData);
            this.$set(data, "addVisible", false);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 编辑弹出框显示
     * @param {*} data
     * @return {*}
     */
    editShow(data) {
      this.$set(data, "addVisible", false);
      this.label = JSON.parse(JSON.stringify(data.name));
      this.$set(data, "label", this.label);
    },
    /**
     * @description: 编辑标签
     * @param {*} data
     * @return {*}
     */
    editLabel(data) {
      this.$http
        .put(global.apiUrl + `/medical/department/edit`, {
          id: data.id,
          name: this.label,
        })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$set(data, "name", this.label);
            this.$set(data, "editVisible", false);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 删除标签
     * @param {*} node
     * @param {*} data
     * @return {*}
     */
    deleteLabel(node, data) {
      this.$http
        .delete(global.apiUrl + `/medical/department/delete?id=${data.id}`)
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            const parent = node.parent;
            const children = parent.data.subDepartments || parent.data;
            const index = children.findIndex(d => d.id === data.id);
            children.splice(index, 1);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.mgl5 {
  margin-left: 5px;
}
.mgl10 {
  margin-left: 10px;
}
</style>
